import { useQuery } from "@tanstack/react-query";
import { ClassReports, UserReports } from "@/types";
import API_ENDPOINTS from "@/data/client/endpoints.ts";
import client from "@/data/client";

interface UserReportsParams {
  userId: string;
  eventId: string;
}

export function useClassReports() {
  const { data, isLoading, error } = useQuery<ClassReports, Error>(
    [API_ENDPOINTS.CLASS_REPORTS],
    client.reports.classReports,
  );
  return {
    reports: data,
    isLoading,
    error,
  };
}

export function useUserReports({ userId, eventId }: UserReportsParams) {
  const { data, isLoading, error } = useQuery<UserReports, Error>(
    [API_ENDPOINTS.USER_REPORTS, userId, eventId],
    () => client.reports.getUserReports(userId, eventId),
    {
      enabled: !!userId && !!eventId
    }
  );

  return {
    reports: data,
    isLoading,
    error,
  };
}